import { AuthService } from 'src/app/Service/AuthService';
import { BaseDisplayController } from '../../BaseUI/BaseDisplayController';
import { MainDisplayComponent } from './MainDisplayComponent';
import { PcrService } from '../../../Service/PcrService';

 /**
 * AppMainViewController
 *
 * Viewの最上位クラスのコントローラー
 */
export class MainDisplayController extends BaseDisplayController {

	// コンポーネントとコントローラーの結合用プロパティは、継承関係上の上書きする。
	// F12での参照が出来うようにする為と、クラス構造で、どのViewと紐づくか明示する為。
	public combineView: MainDisplayComponent;

	/**
	 * constructor
	 *
	 * 本体の受取とかの初期処理
	 */
	constructor() {

		super();

	}

	public async isExistSpecimenNum(param: {view: any}) {
		const svc = new PcrService(param.view);
		const ret = await svc.isExistSpecimenNum();

		return ret;
	}

	public async isExistPassword(param: {view: any}) {

		const svc = new AuthService(param.view);
		const ret = await svc.isExistPassword();

		return ret;

	}

	 /**
	  * ressetingPassword
	  * パスワード再設定のパスワードを送信
	  * @param param viewインスタンス, {再設定トークン、パスワード}
	  */
	 public async createPassword(param: { view: any; password: string}) {

		 const svc = new AuthService(param.view);
		 const ret = await svc.createPassword(param.password);

		 return ret;

	 }


}
